import axios from "axios";
import router from "../../router";
import store from "../../store";
import StoreConstants from "../../store/services/StoreConstants";

let baseURL = process.env.VUE_APP_SERVER_URL || "http://localhost:8081";

export default () => {
  let API = axios.create({
    baseURL: baseURL
  });

  API.interceptors.request.use(config => {
    let token = store.state.session;
    config.headers.common["Authorization"] = `Bearer ${token}`;
    return config;
  });

  API.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      let data = error.response;
      if (data.status === 401) {
        return store.dispatch(StoreConstants.ACTIONS.SIGN_OUT).then(() => {
          router.push({ name: "Login" });
        });
      }
      return Promise.reject(data);
    }
  );

  return API;
};
